import React, { useState, useEffect } from "react";
import myConfig from "../../configs/config";
import MDSpinner from "react-md-spinner";
import { withTranslation } from "react-i18next";
import ExportButton from "../../components/Export_button";
import AddButton from "../../components/Add_button";
import { isChildrenEmpty } from "../../helpers/utils";
import { Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import BackButton from "../../components/BackButton";
import "./FuelPump.css";
import "../Operation/Operation.css";
import QRCode from "qrcode";
import Modal from "@material-ui/core/Modal";

import { FaEdit, FaTrashAlt, FaQrcode } from "react-icons/fa";

function ListFuelPump(props) {
  const farmId = props.match.params.farm_id;

  const [listFuelPumps, setFuelPumps] = useState([]);
  const [loading, setLoading] = useState();
  const [showQRModal, setShowQRModal] = useState(false);
  const [qrCodeData, setQrCodeData] = useState("");
  const [selectedFuelPump, setSelectedFuelPump] = useState(null);

  useEffect(() => {
    getFuelPumps();
  }, []);

  async function getFuelPumps() {
    if (loading) {
      console.log("Já está carregando, ignorando nova chamada");
      return;
    }

    setLoading(true);

    try {
      let FUEL_PUMP_LIST_URL = `https://agriconnected-ga4-default-rtdb.firebaseio.com/fuel-pumps.json`;

      const response = await fetch(FUEL_PUMP_LIST_URL, {
        method: "GET",
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      let data = await response.json();

      if (data && Array.isArray(data)) {
        setFuelPumps(data);
      } else if (data && typeof data === "object") {
        const arrayData = Object.entries(data).map(([key, value]) => ({
          ...value,
          id: key,
        }));
        setFuelPumps(arrayData);
      } else {
        setFuelPumps([]);
      }
    } catch (error) {
      console.log("Erro ao carregar bombas de combustível:", error);

      let errorMessage = "Falha ao carregar bombas de combustível";

      if (error.name === "AbortError") {
        errorMessage = "Timeout: A requisição demorou muito para responder.";
      } else if (error.message.includes("HTTP error!")) {
        const match = error.message.match(/\d+/);
        const status = match ? parseInt(match[0]) : 0;
        switch (status) {
          case 401:
            errorMessage = "Não autorizado. Faça login novamente.";
            break;
          case 403:
            errorMessage =
              "Você não tem permissão para acessar essas informações.";
            break;
          case 404:
            errorMessage = "Serviço não encontrado. Verifique a conexão.";
            break;
          case 500:
            errorMessage =
              "Erro interno do servidor. Tente novamente mais tarde.";
            break;
          default:
            errorMessage = `Erro do servidor: ${status}`;
        }
      } else if (
        error.message.includes("Failed to fetch") ||
        error.message.includes("NetworkError")
      ) {
        // Erro de rede
        console.log("Erro de rede:", error);
        errorMessage =
          "Erro de conexão. Verifique sua internet e tente novamente.";
      }

      alert(errorMessage);
    } finally {
      setLoading(false);
    }
  }

  async function deleteFuelPump(fuelPumpId) {
    if (
      window.confirm(
        "Tem certeza que deseja excluir esta bomba de combustível?"
      )
    ) {
      try {
        let DELETE_URL = `${myConfig.API_URL}/fuel_pump/${fuelPumpId}/`;

        const response = await fetch(DELETE_URL, {
          method: "DELETE",
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        toast.success("Bomba de combustível excluída com sucesso!");
        getFuelPumps();
      } catch (error) {
        console.log("Erro ao excluir bomba de combustível:", error);

        let errorMessage = "Erro ao excluir bomba de combustível";

        if (error.message.includes("HTTP error!")) {
          const match = error.message.match(/\d+/);
          const status = match ? parseInt(match[0]) : 0;
          switch (status) {
            case 401:
              errorMessage = "Não autorizado. Faça login novamente.";
              break;
            case 403:
              errorMessage = "Você não tem permissão para excluir esta bomba.";
              break;
            case 404:
              errorMessage = "Bomba de combustível não encontrada.";
              break;
            case 409:
              errorMessage =
                "Não é possível excluir esta bomba pois está sendo utilizada.";
              break;
            default:
              errorMessage = `Erro do servidor: ${status}`;
          }
        } else if (
          error.message.includes("Failed to fetch") ||
          error.message.includes("NetworkError")
        ) {
          errorMessage = "Erro de conexão. Verifique sua internet.";
        }

        toast.error(errorMessage);
      }
    }
  }

  function renderFuelPumpStatus(status) {
    const statusMap = {
      active: { text: "Ativa", class: "badge-success" },
      inactive: { text: "Inativa", class: "badge-secondary" },
      maintenance: { text: "Em Manutenção", class: "badge-warning" },
    };

    const statusInfo = statusMap[status] || {
      text: status,
      class: "badge-info",
    };

    return (
      <span className={`badge ${statusInfo.class}`}>{statusInfo.text}</span>
    );
  }

  async function generateQRCode(fuelPump) {
    try {
      const qrCodeURL = await QRCode.toDataURL(fuelPump.id, {
        width: 300,
        margin: 2,
        color: {
          dark: "#000000",
          light: "#FFFFFF",
        },
      });

      setQrCodeData(qrCodeURL);
      setSelectedFuelPump(fuelPump);
      setShowQRModal(true);
    } catch (error) {
      console.error("Erro ao gerar QR Code:", error);
      toast.error("Erro ao gerar QR Code");
    }
  }

  if (loading) {
    return (
      <div className="container-fluid">
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ minHeight: "400px" }}
        >
          <div className="text-center">
            <MDSpinner />
            <p className="mt-3 text-muted">
              Carregando bombas de combustível...
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      <div id="fuel_pump_list_container">
        <div className="x_title">
          <BackButton to={`/${farmId}`} label={props.t("Voltar")} />
          <h2>{props.t("Bombas de Combustível")}</h2>
          <div className="clearfix"></div>
        </div>

        <AddButton
          url={`/${farmId}/fuel-pump/add/`}
          classname="btn btn-primary btn-default-add"
        />
        <ExportButton
          classname="btn btn-default-export"
          export={`${myConfig.API_URL}/fuel_pump/export/?farm_id=${farmId}`}
        />

        {isChildrenEmpty(
          listFuelPumps,
          <h4 align="center">
            {props.t(
              "Esta fazenda ainda não possui nenhuma bomba de combustível cadastrada."
            )}
          </h4>,
          <table className="table table-striped">
            <thead>
              <tr>
                <th>{props.t("Identificação")}</th>
                <th>{props.t("Tipo de Combustível")}</th>
                <th>{props.t("Capacidade (L)")}</th>
                <th>{props.t("Status")}</th>
                <th>{props.t("Localização")}</th>
                <th className="text-center">{props.t("Ação")}</th>
              </tr>
            </thead>
            <tbody>
              {listFuelPumps.map((fuelPump) => (
                <tr key={fuelPump.id}>
                  <td>
                    <strong>{fuelPump.id}</strong>
                    {fuelPump.model && (
                      <div className="small text-muted">
                        {fuelPump.brand} - {fuelPump.model}
                      </div>
                    )}
                  </td>
                  <td>
                    <span className="badge badge-primary">
                      {fuelPump.fuel_type}
                    </span>
                  </td>
                  <td>{fuelPump.capacity ? `${fuelPump.capacity} L` : "-"}</td>
                  <td>{renderFuelPumpStatus(fuelPump.status)}</td>
                  <td>{fuelPump.location || "-"}</td>
                  <td align="center">
                    <div className="btn-group">
                      <Link to={`${fuelPump.id}/`} className="btn">
                        <FaEdit />
                      </Link>
                      <button
                        onClick={(event) => {
                          event.preventDefault();
                          generateQRCode(fuelPump);
                        }}
                        className="btn"
                        type="button"
                        title="Gerar QR Code"
                      >
                        <FaQrcode />
                      </button>
                      <button
                        onClick={(event) => {
                          event.preventDefault();
                          deleteFuelPump(fuelPump.id);
                        }}
                        className="btn"
                        type="button"
                      >
                        <FaTrashAlt />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      <Modal
        aria-labelledby="qr-modal-title"
        aria-describedby="qr-modal-description"
        open={showQRModal}
        onClose={() => setShowQRModal(false)}
      >
        <div className="modal-size qr-modal-container">
          <div className="qr-modal-header">
            <h5 className="qr-modal-title">
              <i className="fas fa-qrcode"></i>
              QR Code - Bomba {selectedFuelPump && selectedFuelPump.id}
            </h5>
          </div>

          <div className="qr-modal-body">
            {qrCodeData ? (
              <div>
                <div className="qr-code-container">
                  <img
                    src={qrCodeData}
                    alt="QR Code da Bomba de Combustível"
                    className="qr-code-image"
                  />
                </div>

                {selectedFuelPump && (
                  <div className="qr-pump-details">
                    <h6>
                      <i className="fas fa-info-circle"></i> Detalhes da Bomba
                    </h6>
                    <p>
                      <strong>ID:</strong> {selectedFuelPump.id}
                    </p>
                    <p>
                      <strong>Nome:</strong> {selectedFuelPump.name || "N/A"}
                    </p>
                    <p>
                      <strong>Status:</strong>{" "}
                      {selectedFuelPump.status || "N/A"}
                    </p>
                    <p>
                      <strong>Tipo de Combustível:</strong>{" "}
                      {selectedFuelPump.fuel_type || "N/A"}
                    </p>
                  </div>
                )}

                <p className="qr-info-text">
                  <i className="fas fa-mobile-alt"></i>
                  Escaneie este QR Code com seu dispositivo móvel para acessar
                  rapidamente as informações da bomba de combustível
                </p>
              </div>
            ) : (
              <div className="qr-loading">
                <div className="qr-loading-spinner"></div>
                <p>Gerando QR Code...</p>
              </div>
            )}
          </div>

          <div className="qr-modal-footer">
            <button
              type="button"
              onClick={() => setShowQRModal(false)}
              className="qr-btn qr-btn-secondary"
            >
              <i className="fas fa-times"></i>
              Fechar
            </button>
            {qrCodeData && (
              <a
                href={qrCodeData}
                download={`qrcode-bomba-${
                  selectedFuelPump && selectedFuelPump.id
                }.png`}
                className="qr-btn qr-btn-primary"
              >
                <i className="fas fa-download"></i>
                Baixar QR Code
              </a>
            )}
          </div>
        </div>
      </Modal>

      <ToastContainer />
    </>
  );
}

export default React.memo(withTranslation()(ListFuelPump));
